import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { HebDateUtil } from '../Util/HebDateUtil';
import { HDate } from '@hebcal/core';
import { GetPerek, GetPerekHeader, GetPerekNext, GetPerekPrev } from '../Util/Prakim';



const HeaderPerek = (props) => {
  const navigate = useNavigate();
  let params = useParams();
  const [statePerekHeader, setStatePerekHeader] = useState(1);
  const [statePerekNext, setStatePerekNext] = useState(1);
  const [statePerekPrev, setStatePerekPrev] = useState(1);


  useEffect(() => {
    setStatePerekHeader(GetPerekHeader(params.type, params.id));
    setStatePerekNext(GetPerekNext(params.type, params.id));
    setStatePerekPrev(GetPerekPrev(params.type, params.id));
  }, [params.type, params.id]);


  return (
    <div className='shiur-header'>
      <div className='shiur-buttons'>
          <a onClick={ () => { navigate(`/pr/${params.type}/${statePerekPrev}`); window.scrollTo(0,0); } }>פרק קודם</a>
          <b>{ statePerekHeader }</b>
          <a onClick={ () => { navigate(`/pr/${params.type}/${statePerekNext}`); window.scrollTo(0,0); } }>פרק הבא</a>
      </div>
    </div>
  );
}

export default HeaderPerek;